import React from 'react';
import { motion } from 'framer-motion';
import { Medal, MapPin, Target, Heart } from 'lucide-react';
export function Hero() {
  return <section id="home" className="relative bg-usa-navy pt-28 sm:pt-32 min-h-[90vh] flex flex-col overflow-hidden" data-id="element-84">
      {/* Full-bleed background image */}
      <div className="absolute inset-0 z-0" data-id="element-85">
        <img src="https://www.tkdfuture.com/uploaded/feedback_upload/20230826_185551_705489_IMG_7035.jpeg" alt="" aria-hidden="true" className="w-full h-full object-cover object-center" data-id="element-86" />
        {/* Dark overlay for readability */}
        <div className="absolute inset-0 bg-usa-navy/80" data-id="element-87" />
        {/* Red accent gradient block - solid sided */}
        <div className="absolute inset-y-0 left-0 w-full md:w-2/3 bg-usa-navy/60" data-id="element-88" />
      </div>

      <div className="flex-grow flex items-center relative z-10" data-id="element-89">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 lg:py-20 w-full" data-id="element-90">
          <div className="grid lg:grid-cols-12 gap-12 items-center" data-id="element-91">
            {/* Text Content */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.6
          }} className="lg:col-span-8 text-center lg:text-left" data-id="element-92">
              <div className="inline-flex items-center gap-2 px-3 py-1 bg-usa-blue/40 backdrop-blur-sm text-usa-gold font-medium text-sm uppercase tracking-wider mb-6 border border-usa-gold/40" data-id="element-93">
                <Medal size={16} data-id="element-94" />
                <span data-id="element-95">USA Taekwondo Athlete</span>
              </div>

              <h1 className="text-5xl sm:text-6xl lg:text-7xl xl:text-8xl font-display font-bold text-white leading-[1.05] mb-6 drop-shadow-lg" data-id="element-96">
                HELP CYRUS BARBOUR REACH HIS{' '}
                <span className="text-usa-red" data-id="element-97">OLYMPIC GOALS</span>
              </h1>

              <p className="text-lg sm:text-xl text-gray-200 mb-8 max-w-2xl mx-auto lg:mx-0 leading-relaxed drop-shadow" data-id="element-98">
                Support Cyrus's Taekwondo journey as he trains, competes, leads,
                and works toward earning a place on the USA Taekwondo Team.
              </p>

              <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start" data-id="element-99">
                <a href="#donate" className="bg-usa-red hover:bg-red-700 text-white font-display text-xl px-8 py-4 tracking-wider transition-colors text-center shadow-lg shadow-red-900/40" data-id="element-100">
                  SUPPORT CYRUS
                </a>
                <a href="#sponsor" className="bg-transparent border-2 border-white hover:bg-white hover:text-usa-navy text-white font-display text-xl px-8 py-4 tracking-wider transition-colors text-center" data-id="element-101">
                  BECOME A SPONSOR
                </a>
              </div>
            </motion.div>

            {/* "This is Cyrus" Identifier Badge */}
            <motion.div initial={{
            opacity: 0,
            scale: 0.9
          }} animate={{
            opacity: 1,
            scale: 1
          }} transition={{
            duration: 0.6,
            delay: 0.3
          }} className="lg:col-span-4 mx-auto lg:mx-0 lg:justify-self-end" data-id="element-102">
              <div className="relative inline-block" data-id="element-103">
                {/* Decorative accent */}
                <div className="absolute -top-2 -right-2 w-16 h-16 bg-usa-red z-0" data-id="element-104" />
                <div className="absolute -bottom-2 -left-2 w-20 h-20 bg-usa-gold z-0" data-id="element-105" />

                <div className="relative z-10 bg-usa-navy border-4 border-white shadow-2xl p-3 w-56 sm:w-64" data-id="element-106">
                  <div className="aspect-square overflow-hidden mb-3" data-id="element-107">
                    <img src="https://drwzpk38qkpfb.cloudfront.net/www.tkdfuture.com/uploaded/images/Misc%20icons%20and%20images/Cyrus-Barbour-Home.jpeg" alt="Portrait of Cyrus Barbour" className="w-full h-full object-cover" data-id="element-108" />
                  </div>
                  <div className="text-center" data-id="element-109">
                    <span className="block font-display text-white text-xl tracking-wide" data-id="element-110">
                      Cyrus Barbour
                    </span>
                  </div>
                </div>
              </div>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Stat Strip */}
      <div className="bg-usa-blue border-t border-white/10 relative z-10" data-id="element-111">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6" data-id="element-112">
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 text-white" data-id="element-113">
            <div className="flex items-center gap-4" data-id="element-114">
              <div className="bg-white/10 p-3 rounded-none" data-id="element-115">
                <Medal className="text-usa-gold" size={24} data-id="element-116" />
              </div>
              <span className="text-sm font-medium leading-snug" data-id="element-117">
                Started Taekwondo at age 3
              </span>
            </div>
            <div className="flex items-center gap-4" data-id="element-118">
              <div className="bg-white/10 p-3 rounded-none" data-id="element-119">
                <MapPin className="text-usa-gold" size={24} data-id="element-120" />
              </div>
              <span className="text-sm font-medium leading-snug" data-id="element-121">
                Training and competing across the United States
              </span>
            </div>
            <div className="flex items-center gap-4" data-id="element-122">
              <div className="bg-white/10 p-3 rounded-none" data-id="element-123">
                <Target className="text-usa-gold" size={24} data-id="element-124" />
              </div>
              <span className="text-sm font-medium leading-snug" data-id="element-125">
                Working toward USAT Nationals & Olympic goals
              </span>
            </div>
            <div className="flex items-center gap-4" data-id="element-126">
              <div className="bg-white/10 p-3 rounded-none" data-id="element-127">
                <Heart className="text-usa-gold" size={24} data-id="element-128" />
              </div>
              <span className="text-sm font-medium leading-snug" data-id="element-129">
                100% of support goes directly to Cyrus
              </span>
            </div>
          </div>
        </div>
      </div>
    </section>;
}